import { Divider } from '@mui/material';
import React from 'react'
const moment = require('moment');

const Footer = () => {
    const currentDateTime = moment().format('YYYY');
    const formattedDateTime = `©${currentDateTime}`;
    return (
        <div className='footer'>
            <Divider />
            <div className='content'>
                <p>&copy; {new Date().getFullYear()} Karnataka State Road Transport Corporation | Powered by Amnex Infotechnologies Private Limited & Mantis Technologies Private Limited</p>
            </div>
        </div>
    )
}

export default Footer